import { trigger, state, style, animate, transition } from '@angular/animations';

export const disappear = trigger('disappear', [
    state('inactive', style({})),
    state('active', style({})),
    transition('active=>inactive', [
        animate('550ms ease-in'),
        style({ transform: 'translateX(-35%)', zIndex: -200 })
    ])
    // transition('*=>void', [
    //   animate('500ms ease-out'),
    //   style({ transform: 'translateX(20%)' })
    // ])
]);

export const slideIn = trigger('slideIn', [
    state('in', style({})),
    transition('void=>*', [
        animate('250ms ease-in'),
        style({ transform: 'translateX(-50%)' })
    ]),
    transition('*=>void', [
        animate('300ms ease-out'),
        style({ transform: 'translateX(20%)' })
    ])
]);

// used in user component
export const slideShow = trigger('slideShow', [
    state('in', style({})),
    transition('void=>*', [
        style({
            transform: 'translateX(+150%)',
            height: 'auto',
            zIndex: '200',
            overflow: 'hidden'
        }),
        animate('300ms ease-in')
    ]),
    // transition('*=>void', [
    //   animate('300ms ease-out'),
    //   style({
    //     transform: 'translateX(+150%)',
    //     height: '100%',
    //     zIndex: '200',
    //     overflow: 'hidden'
    //   })
    // ])
]);

export function slideToRight(setheight = '100%') {
    return trigger('slideToRight', [
        state('in', style({})),
        transition('void=>*', [
            style({
                transform: 'translateX(+150%)',
                height: setheight,
                zIndex: '200',
                overflow: 'hidden'
            }),
            animate('300ms ease-in')
        ]),
        transition('*=>void', [
            animate('300ms ease-out'),
            style({
                transform: 'translateX(+150%)',
                height: setheight,
                zIndex: '200',
                overflow: 'hidden'
            })
        ])
    ]);
};

export function slideToTop(setheight = '100%') {
    return trigger('slideToTop', [
        state('in', style({})),
        transition('void=>*', [
            style({
                transform: 'translateY(+150%)',
                height: setheight,
                zIndex: '200',
                overflow: 'hidden'
            }),
            animate('400ms ease-in', style({top:'10px'}))
        ]),
        // set the top to 50px(height of the header) to remove the menu do down animation
        transition('*=>void', [
            animate('400ms ease-out', style({top:'50px'})),
            style({
                transform: 'translateY(+150%)',
                height: setheight,
                zIndex: '200',
                overflow: 'hidden'
            })
        ])
    ]);
};

export function enterAnimation() {
    return trigger(
        'enterAnimation', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('200ms', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                style({ opacity: 1 }),
                animate('200ms', style({ opacity: 0 }))
            ])
        ]
    );
}
